(function () {
	'use strict';

	var blockSelectors = {
		block_accordion_or_tabs: '.accordion-tabs-nav, .accordion-tabs-content, .accordion-tabs-accordion',
		block_bg_with_text: '.bg-with-text-copy, .bg-with-text-content > .dd-buttons',
		block_buttons: '.dd-buttons > .dd-button',
		block_careers: '.careers-image, .careers-jobs > .career-card',
		block_columns: '.block-columns-row > .block-column',
		block_cpt: '.block-cpt-taxonomy-heading, .block-cpt-grid > .block-cpt-item, .block-cpt-slider > .owl-stage-outer, .block-cpt-pagination',
		block_grid_repeater_with_image: '.grid-cards-mode-grid > .grid-card-item, .grid-card-slider > .owl-stage-outer',
		block_images: '.gallery-mode-grid > .gallery-item, .gallery-mode-masonry > .gallery-item, .gallery-slider > .owl-stage-outer',
		block_logos: '.logos-mode-grid > .logos-item, .logos-slider > .owl-stage-outer',
		block_master_text: '.master-text-content > *, .dd-buttons',
		block_mission_vision: '.mission-vision-title, .mission-vision-feature, .mission-vision-cta',
		block_challenge_solution: '.challenge-solution-intro, .challenge-solution-stage, .challenge-solution-switcher',
		block_process: '.process-grid > .process-item',
		block_tables: '.tables-group',
		block_taxonomy_posts: '.taxonomy-posts-group-header, .taxonomy-posts-grid > .block-cpt-item, .taxonomy-posts-slider > .owl-stage-outer',
		block_testimonials: '.testimonials-intro > *, .testimonials-slider-viewport',
		block_text_accordion: '.text-accordion-content, .text-accordion > .text-accordion-item',
		block_text_image: '.text-image-content > *, .text-image-media-frame',
		block_timeline: '.project-timeline[data-timeline-animation="0"]',
		block_why_bts: '.why-bts-grid > .why-bts-card'
	};

	var headerSelector = [
		'.section-header > .section-subtitle',
		'.section-header > .main-title',
		'.section-header > .section-header-description'
	].join(', ');

	function revealAnimationContent() {
		window.clearTimeout(window.ddAnimationFallback);
		document.documentElement.classList.remove('dd-animations-pending');
	}

	function uniqueVisibleElements(elements) {
		return elements.filter(function (element, index, list) {
			return list.indexOf(element) === index
				&& !element.closest('.owl-item.cloned')
				&& element.getClientRects().length;
		});
	}

	function getContentTargets(section) {
		var selectors = [];

		Object.keys(blockSelectors).forEach(function (blockClass) {
			if (section.classList.contains(blockClass)) {
				selectors.push(blockSelectors[blockClass]);
			}
		});

		if (!selectors.length) {
			return [];
		}

		return uniqueVisibleElements(Array.prototype.slice.call(section.querySelectorAll(selectors.join(', '))));
	}

	function animateHeader(section) {
		var targets = uniqueVisibleElements(Array.prototype.slice.call(section.querySelectorAll(headerSelector)));

		if (!targets.length) {
			return;
		}

		window.gsap.fromTo(targets, {
			autoAlpha: 0,
			y: 24
		}, {
			autoAlpha: 1,
			y: 0,
			duration: 0.72,
			stagger: 0.1,
			ease: 'power3.out',
			clearProps: 'transform,opacity,visibility',
			scrollTrigger: {
				trigger: section,
				start: 'top 84%',
				once: true
			}
		});
	}

	function animateContent(section) {
		var targets = getContentTargets(section);

		if (!targets.length) {
			return;
		}

		window.gsap.set(targets, {
			autoAlpha: 0,
			y: 32,
			force3D: true
		});

		window.ScrollTrigger.batch(targets, {
			start: 'top 88%',
			once: true,
			onEnter: function (batch) {
				window.gsap.to(batch, {
					autoAlpha: 1,
					y: 0,
					duration: 0.72,
					stagger: 0.08,
					ease: 'power3.out',
					overwrite: 'auto',
					clearProps: 'transform,opacity,visibility'
				});
			}
		});
	}

	function animateHeroPanel(panel) {
		var content = panel ? panel.querySelector('.page-hero-content') : null;

		if (!content || content.dataset.ddGsapAnimation) {
			return;
		}

		var targets = uniqueVisibleElements(Array.prototype.slice.call(content.querySelectorAll([
			'.page-hero-subtitle',
			'.page-hero-title',
			'.page-hero-description',
			'.page-hero-post-meta',
			'.page-hero-buttons > .dd-button'
		].join(', '))));
		var pattern = panel.querySelector('.page-hero-pattern');
		var timeline = window.gsap.timeline({
			defaults: {
				ease: 'power3.out'
			}
		});

		content.dataset.ddGsapAnimation = '1';

		if (pattern) {
			timeline.fromTo(pattern, {
				autoAlpha: 0,
				x: 70
			}, {
				autoAlpha: 1,
				x: 0,
				duration: 1.15,
				clearProps: 'transform,opacity,visibility'
			}, 0);
		}

		if (targets.length) {
			timeline.fromTo(targets, {
				autoAlpha: 0,
				y: 30
			}, {
				autoAlpha: 1,
				y: 0,
				duration: 0.78,
				stagger: 0.1,
				clearProps: 'transform,opacity,visibility'
			}, 0.16);
		}
	}

	function initHeaderImageAnimation() {
		var hero = document.querySelector('#header-image.page-hero');

		if (!hero || hero.dataset.ddGsapAnimation) {
			return;
		}

		hero.dataset.ddGsapAnimation = '1';

		if (hero.classList.contains('page-hero-slider')) {
			var activePanel = hero.querySelector('.carousel-item.active');
			animateHeroPanel(activePanel);

			if (window.jQuery) {
				window.jQuery(hero).on('slid.bs.carousel.ddGsap', function (event) {
					animateHeroPanel(event.relatedTarget || hero.querySelector('.carousel-item.active'));
				});
			}

			return;
		}

		animateHeroPanel(hero);
	}

	function initPrefooterAnimation() {
		var section = document.querySelector('.pre-footer-cta');

		if (!section || section.dataset.ddGsapAnimation) {
			return;
		}

		var background = section.querySelector('.pre-footer-cta-background');
		var targets = uniqueVisibleElements(Array.prototype.slice.call(section.querySelectorAll([
			'.pre-footer-cta-title',
			'.pre-footer-cta-main-title',
			'.pre-footer-cta-description',
			'.pre-footer-cta-buttons > .dd-button',
			'.pre-footer-cta-email'
		].join(', '))));
		var timeline = window.gsap.timeline({
			scrollTrigger: {
				trigger: section,
				start: 'top 80%',
				once: true
			}
		});

		section.dataset.ddGsapAnimation = '1';

		if (background) {
			timeline.fromTo(background, {
				scale: 1.07
			}, {
				scale: 1,
				duration: 1.4,
				ease: 'power2.out',
				clearProps: 'transform'
			}, 0);
		}

		if (targets.length) {
			timeline.fromTo(targets, {
				autoAlpha: 0,
				y: 28
			}, {
				autoAlpha: 1,
				y: 0,
				duration: 0.72,
				stagger: 0.1,
				ease: 'power3.out',
				clearProps: 'transform,opacity,visibility'
			}, 0.12);
		}
	}

	function initStandaloneAnimations() {
		if (!window.gsap || !window.ScrollTrigger || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
			return;
		}

		window.gsap.registerPlugin(window.ScrollTrigger);
		initHeaderImageAnimation();
		initPrefooterAnimation();
	}

	function initBlockAnimations(context) {
		var root = context && context.querySelectorAll ? context : document;
		var sections = Array.prototype.slice.call(root.querySelectorAll('.dd-section'));

		if (!window.gsap || !window.ScrollTrigger || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
			return;
		}

		window.gsap.registerPlugin(window.ScrollTrigger);

		sections.forEach(function (section) {
			if (section.dataset.ddGsapAnimation || section.classList.contains('no-gsap-animation')) {
				return;
			}

			section.dataset.ddGsapAnimation = '1';
			animateHeader(section);
			animateContent(section);
		});

		window.requestAnimationFrame(function () {
			window.ScrollTrigger.refresh();
		});
	}

	window.ddInitBlockAnimations = initBlockAnimations;

	document.addEventListener('dd:blocks:ready', function () {
		initBlockAnimations(document);
	});

	document.addEventListener('DOMContentLoaded', function () {
		initStandaloneAnimations();

		window.setTimeout(function () {
			initBlockAnimations(document);

			window.requestAnimationFrame(function () {
				revealAnimationContent();
			});
		}, 50);
	});

	window.addEventListener('load', function () {
		if (window.ScrollTrigger) {
			window.ScrollTrigger.refresh();
		}
	});
})();
